/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Collection_DescriptionInputs */

const en_directory_taxonomy_index_collection_description = /** @type {(inputs: Directory_Taxonomy_Index_Collection_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections bring related products together around a workflow, goal, or way of working.`)
};

const zh_directory_taxonomy_index_collection_description = /** @type {(inputs: Directory_Taxonomy_Index_Collection_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集围绕工作流、目标或工作方式，把相关产品组织在一起。`)
};

/**
* | output |
* | --- |
* | "Collections bring related products together around a workflow, goal, or way of working." |
*
* @param {Directory_Taxonomy_Index_Collection_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_collection_description = /** @type {((inputs?: Directory_Taxonomy_Index_Collection_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Collection_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_collection_description(inputs)
	return zh_directory_taxonomy_index_collection_description(inputs)
});
export { directory_taxonomy_index_collection_description as "directory.taxonomy_index.collection.description" }